<template>
	<v-container>
		<v-card outlined>
			<v-card-title
				v-text="tableHeader"
			/>
			<v-card-text>
				<v-form ref="form" @submit.stop.prevent="submitFilters">
					<v-row>
						<v-col cols="12">
							<v-text-field
								:value="$route.query.search"
								name="search"
								label="Поиск по наименованию/артикулу"
								outlined
								dense
								clearable
								hide-details
							>
								<template #append-outer>
									<v-tooltip left>
										<template #activator="{ on }">
											<v-btn
												icon
												text
												small
												v-on="on"
												@click="moreFilters = !moreFilters"
											>
												<v-icon v-if="moreFilters">mdi-chevron-up</v-icon>
												<v-icon v-else>mdi-chevron-down</v-icon>
											</v-btn>
										</template>
										<span v-if="moreFilters">Спрятать фильтры</span>
										<span v-else>Больше фильтров</span>
									</v-tooltip>
								</template>
							</v-text-field>
						</v-col>

						<template v-if="moreFilters">
							<v-col cols="12" md="3">
								<v-autocomplete
									:value="$route.query.group"
									:search-input.sync="autocompletes.group.term"
									:items="autocompletes.group.items"
									label="Группа товаров"
									name="group"
									item-text="name"
									item-value="id"
									autocomplete="off"
									outlined
									dense
									clearable
									hide-details
								/>
							</v-col>
							<v-col cols="12" md="3">
								<v-select
									:value="$route.query.image"
									name="image"
									:items="selects.image"
									label="Изображение"
									outlined
									dense
									clearable
									hide-details
								/>
							</v-col>
							<v-col cols="12" md="3">
								<v-select
									:value="$route.query.onec"
									name="onec"
									:items="selects.onec"
									label="Идентификатор 1С"
									outlined
									dense
									clearable
									hide-details
								/>
							</v-col>
						</template>

						<v-col cols="12">
							<v-btn
								type="submit"
								class="mr-2"
								outlined
							>
								Применить
							</v-btn>
							<v-btn
								color="grey"
								class="mr-2"
								outlined
								@click.stop="clearFilters"
							>
								Сбросить
							</v-btn>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-data-table
				:headers="headers"
				:items="products.data"
				:server-items-length="products.meta.total"
				:loading="loading"
				loading-text="Загрузка..."
				disable-sort
				@update:page="fetchProducts($event, products.meta.per_page, getFilters())"
				@update:items-per-page="fetchProducts(1, $event, getFilters())"
				@click:row="rowClick"
			>
				<template #header.image>
					<v-icon>mdi-image-outline</v-icon>
				</template>

				<template #item.image="{ item: product }">
					<v-img
						v-if="product.media.images"
						:src="product.media.images.url"
						max-width="30"
					/>
					<v-icon
						v-else
						color="grey lighten-2"
					>
						mdi-image-off-outline
					</v-icon>
				</template>
				<template #item.name="{ item: product }">
					<component :is="product.deleted_moysklad ? 's' : 'span'">
						{{ product.name }}
					</component>
				</template>
				<template #item.vendor_code="{ item: product }">
					{{ product.vendor_code }}
					<v-tooltip
						top
						content-class="top"
						v-if="product.additional_vendor_codes.length > 0"
						open-on-click
						:open-on-hover="false"
					>
						<template v-slot:activator="{ on }">
							<v-icon
								color="blue"
								v-on="on"
							>
								mdi-dots-horizontal
							</v-icon>
						</template>
						Дополнительные артикулы:
						<p
							v-for="(vc, key) in product.additional_vendor_codes"
							:key="key"
							class="mb-0"
						>
							{{ vc.code }}
						</p>
					</v-tooltip>
				</template>
				<template #item.sale-price="{ item: product }">
					{{ product.prices.sale_rub }}₽
				</template>
				<template #item.onec_id="{ item: product }">
					<v-edit-dialog
						persistent
						@save="update1cId(product, newOnecId)"
						@open="open1cIdDialog(product)"
					>
						{{ product.onec_id }}
						<template #input>
							<v-text-field
								v-model="newOnecId"
								label="Идентификатор 1С"
								single-line
							></v-text-field>
						</template>
					</v-edit-dialog>
				</template>
			</v-data-table>
		</v-card>
	</v-container>
</template>

<script>
import axios from 'axios';
import qs from 'qs';

const HEADERS = [
	{text: 'Изображение', value: 'image'},
	{text: 'Наименование', value: 'name'},
	{text: 'Артикул', value: 'vendor_code'},
	{text: 'Идентификатор 1С', value: 'onec_id'},
	{text: 'Цена продажи', value: 'sale-price', display: false},
	{text: 'Группа', value: 'group_name'},
	{text: 'Код', value: 'code', display: false},
	// { text: 'Действия', value: 'actions', align: 'end', class: [ 'text-no-wrap' ] },
];
const DEFAULT_LIMIT = 10;

export default {
	name: 'index',
	data: () => ({
		loading: false,
		loadingFixError: false,
		products: {
			data: [],
			meta: {
				total: 0,
				current_page: 1,
				per_page: 10,
			},
		},
		moreFilters: true,
		autocompletes: {
			group: {
				term: '',
				items: [],
			},
		},
		selects: {
			image: [
				{text: 'Неважно', value: null},
				{text: 'Есть', value: 'has'},
				{text: 'Нет', value: 'no'},
			],
			onec: [
				{text: 'Неважно', value: null},
				{text: 'Заполнен', value: 'filled'},
				{text: 'Не заполнен', value: 'empty'},
			],
		},
		newOnecId: '',
	}),
	computed: {
		headers() {
			return HEADERS;
		},
		tableHeader() {
			if (this.isErrorResolve) {
				return `Исправление ошибки по артикулу ${this.$route.params.crossCode}`
			}
			return 'Товары'
		},
		isErrorResolve() {
			return !!(this.$route.params.errorFixMode
				&& this.$route.params.errorId
				&& this.$route.params.crossCode);
		},
		isSimpleMode() {
			return !this.isErrorResolve;
		},
	},
	watch: {
		'autocompletes.group.term'(val) {
			this.searchGroups(val);
		},
	},
	async created() {
		await this.searchGroups();
	},
	async mounted() {
		this.CancelToken = axios.CancelToken;
		this.sourceProducts = this.CancelToken.source();
		this.sourceGroups = this.CancelToken.source();
		this.sourceMachines = this.CancelToken.source();
		await this.fetchProducts(1, DEFAULT_LIMIT, this.getFilters());
	},
	methods: {
		async rowClick(product) {
			if (this.isSimpleMode) {
				await this.$router.push(`/products/${product.id}`)
			} else {
				await this.resolveError(product.id)
			}
		},
		async resolveError(productId) {
			if (this.loadingFixError) return;
			this.loadingFixError = true;
			try {
				await Promise.all([
					this.$http.put(`/api/v1/imports/comparisons/errors/${this.$route.params.errorId}`, {
						state: 'resolved',
					}),
					this.$http.post(`/api/v1/products/${productId}/vendorCodes`, {
						code: this.$route.params.crossCode,
					}),
				])
				this.$notify('Ошибка исправлена');
				await this.$router.push({
					name: 'Machines Import',
				});
			} catch (e) {
			} finally {
				this.loadingFixError = false;
			}
		},
		async fetchProducts(page = 1, limit = null, filter = {}) {
			this.loading = true;
			limit = limit ? limit : this.products.meta.per_page;
			try {
				this.sourceProducts.cancel('Operation cancelled by user');
				this.sourceProducts = this.CancelToken.source();
				const response = await this.$http.get('/api/v2/products', {
					params: {
						page,
						limit,
						filter,
					},
					cancelToken: this.sourceProducts.token,
				});

				this.products = response.data;
				if (this.isSimpleMode) {
					await this.setFiltersToURL(filter);
				}
			} catch (e) {
				if (!axios.isCancel(e)) {
					this.$notify.error('Ошибка загрузки товаров');
				}
			} finally {
				this.loading = false;
			}
		},
		getFilters() {
			const initial = Object.fromEntries((new FormData(this.$refs.form.$el).entries()));
			return Object.keys(initial)
				.reduce((acc, key) => {
					if (!!initial[key]) {
						acc[key] = initial[key];
					}
					return acc;
				}, {});
		},
		submitFilters() {
			this.fetchProducts(1, DEFAULT_LIMIT, this.getFilters());
		},
		clearFilters() {
			this.$refs.form.reset();
			this.fetchProducts();
		},
		async setFiltersToURL(filters) {
			const query = qs.stringify(filters, {
				allowDots: true,
				skipNulls: true,
				encodeValuesOnly: true,
			});
			try {
				if (query.length) {
					await this.$router.push(`${this.$route.path}?${query}`)
				} else {
					await this.$router.push(this.$route.path);
				}
			} catch (e) {
			}
		},
		async searchGroups(term = '') {
			try {
				this.sourceGroups.cancel('Operation cancelled by user');
				this.sourceGroups = this.CancelToken.source();
				const response = await this.$http.get('/api/v2/products/groups', {
					params: {
						filter: {
							search: term,
						},
					},
					cancelToken: this.sourceGroups.token,
				});
				this.autocompletes.group.items = response.data.data;
			} catch (e) {
			}
		},
		open1cIdDialog(product) {
			if (product.onec_id === null) {
				this.newOnecId = '';

				return
			}

			this.newOnecId = product.onec_id
		},
		async update1cId(product, newOnecId) {
			if (product.onec_id === newOnecId) {
				return
			}

			await this.$http.put(`/api/v2/products/${product.id}/onecId`, {
				onec_id: newOnecId,
			}, {
				params: {
					'_method': 'PUT',
				},
			})

			this.products.data = this.products.data.map(p => {
				if (p.id === product.id) {
					p.onec_id = newOnecId
				}

				return p
			})
		},
	},
}
</script>

<style scoped>

</style>
